var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-ag',{ref:"agLeaders",attrs:{"row-data":_vm.datos,"columnDefs":_vm.columns,"typeSelection":_vm.limitSelection > 1 ? 'multiple' : 'single',"limitSelection":_vm.limitSelection,"component-menu":_vm.componentMenu,"onDeselectEmptyData":true},on:{"selected":_vm.selected}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbfc9a3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lideres/components/tableLeaders.vue
// module id = 1231
// module chunks = 2